import React, { useEffect, useState } from "react";

const SECTIONS = [
  { id: "hero", label: "Home" },
  { id: "blueprint", label: "Blueprint" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="primary-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#040508]/70 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("hero")}
          className="font-serif text-xl text-white tracking-wide flex items-center gap-2"
        >
          <span className="w-2 h-2 rounded-full bg-[#D4AF37] shadow-[0_0_12px_#D4AF37]" />
          <span>Kama <span className="gold-text">Loka Journeys</span></span>
        </button>

        <ul className="hidden md:flex items-center gap-10">
          {SECTIONS.map((s) => (
            <li key={s.id}>
              <button
                data-testid={`nav-link-${s.id}`}
                onClick={() => scrollTo(s.id)}
                className="font-sans text-xs uppercase tracking-overline text-slate-300 hover:text-[#D4AF37] transition-colors"
              >
                {s.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-cta-sessions"
          onClick={() => scrollTo("sessions")}
          className="hidden md:inline-flex btn-gold rounded-full px-5 py-2 text-xs"
        >
          Book a session
        </button>
      </div>
    </nav>
  );
}
